function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var InavigateBottom = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2136 5.20266L11.2136 16.3727L6.33359 11.4927C5.94359 11.1027 5.30359 11.1027 4.91359 11.4927C4.52359 11.8827 4.52359 12.5127 4.91359 12.9027L11.5036 19.4927C11.8936 19.8827 12.5236 19.8827 12.9136 19.4927L19.5036 12.9027C19.8936 12.5127 19.8936 11.8827 19.5036 11.4927C19.1136 11.1027 18.4836 11.1027 18.0936 11.4927L13.2136 16.3727L13.2136 5.20266C13.2136 4.65266 12.7636 4.20266 12.2136 4.20266C11.6636 4.20266 11.2136 4.65266 11.2136 5.20266Z",
    fill: "#495057"
  }));
});